<template>
<section>

  <div id="tabletIn" v-if="show">

  {{ worldName }}
    <!--h1> world:{{selectProduct(region,worldName)}} </h1>-->

    <h1>  {{ worldName }}</h1>
    <b-form @submit="onSubmit" v-if="show">
      <p style="font-size: 11px; color:#de1a21;">You must submit this assessment to go back to the home page.</p>
      <b-form-group id="input-group-1" :label="this.dynaQuestions['question1']['questionText']" label-for="input-1">
        <b-form-select
          id="input-1"
          v-model="question1Answer"
          :options="this.dynaQuestions.question1.questionOptions"
          required
        ></b-form-select>
      </b-form-group>

      <b-form-group id="input-group-2" :label="this.dynaQuestions['question2']['questionText']"  label-for="input-2">
        <b-form-select
          id="input-2"
          v-model="question2Answer"
          :options="this.dynaQuestions.question2.questionOptions"
          required
        ></b-form-select>
      </b-form-group>

 <b-form-group :label="this.dynaQuestions['question3']['questionText']" v-slot="{ ariaDescribedby }">
      <b-form-radio-group
        id="btn-radios-1"
        v-model="selected"
        :options="options"
        :aria-describedby="ariaDescribedby"
        name="radios-btn-default"
        buttons
      ></b-form-radio-group>
    </b-form-group>
      <b-form-group id='input-group-4' :label="this.dynaQuestions['question4']['questionText']" label-for='input-4'>
        <b-form-input  
          id='input4'
           v-model="question4Answer"
          
          required
        ></b-form-input>
      </b-form-group>
      
      
    




<div style="text-align:center">
      <b-button class="neu-button" type="submit" variant="primary">Update Mission Log</b-button>
    </div>
    </b-form>

</div>

<div id="tabletIn" v-else>
         <h2  style="font-size: 16px; color:green;">Form info has been submitted</h2>
 
      <router-link class="neu-button" to="/worlds">Home</router-link>
</div>
  

   
        
</section>
</template>

<script>
import worldNameMixin from '../../shared_methods/worldname_mixin';
import assessmentMixin from '../../shared_methods/assessmentMixin';

export default {
name: 'PageSpecificAssessmentForm',

  props: {
    worldName: String,
  },
     mixins: [worldNameMixin,assessmentMixin],

    data() {
      var assessmentInfo=this.selectAssessmentInfo(process.env.VUE_APP_CURRENT_REGION,this.worldName)
      console.warn("form");
      console.log(assessmentInfo);
      return {

        selected: null,
        options: [
          { text: 'Yes', value: 'yes' },
          { text: 'No', value: 'no' },

        ],
        question1Answer:null,
        question2Answer:null,
        question4Answer:null,
        dynaQuestions:assessmentInfo,
        
        //       region:process.env.VUE_APP_CURRENT_REGION.toLowerCase(),

          //      selected: null,
        //options: [
          //{ text: 'Yes', value: 'yes' },
          //{ text: 'No', value: 'no' },

        //],
        //questionsS:assessmentInfo,
          //  items: [
          //{ worldName:this.$options.name,model:'question1', question: this.$options.name+ '1', },
          //{ worldName:this.$options.name,model:'question2' ,question: this.$options.name+'2' },
          //{ worldName:this.$options.name,model:'question3' ,question: this.$options.name+'3' },
          //{worldName:this.$options.name,model:'question4' , question: this.$options.name+'4' }
        //],
        show:true}
    },
 created(){
    //console.log(this.$store.state.assessment_form_store.mutations);
  


  },
  computed: {
  /*    
    question1: {
      get() {
          //console.warn(this.world)
        return ""
      },
      set(value) {
        this.$store.commit('assessment_form_store/SET_FIRSTNAME',{formid:this.world, value:value});
      },
    },
    question2: {
      get() {
        return this.$store.state.assessment_form_store[this.world].formstate.lastName;
      },
      set(value) {
        this.$store.commit('assessment_form_store/SET_LASTNAME',{formid:this.world, value:value});
      },
    },
    question3: {
      get() {
        return this.$store.state.assessment_form_store[this.world].formstate.message;
      },
      set(value) {
        this.$store.commit('assessment_form_store/SET_MESSAGE',{formid:this.world, value:value});
      },
    },
    question4: {
      get() {
        return this.$store.state.assessment_form_store[this.world].formstate.message;
      },
      set(value) {
        this.$store.commit('assessment_form_store/SET_MESSAGE',{formid:this.world, value:value});
      },
    }*/
    },
  //  ...mapFields('assessment_form_store',[
    //  'form2.formstate.firstName',
      //'form2.formstate.lastName',
      //'form2.formstate.message',
      // ...
    //]),
      methods:{
      // eslint-disable-next-line no-unused-vars
      onSubmit(event) {
        console.log(event);
        event.preventDefault();
                //alert("form Info Saved")
              console.log("alert");
              console.log(this.currentUser);
              console.log(this.$store.state.user.currentUser.id);
       var forminfo=
                {worldName:this.worldName,
                question1:{

                  answer:this.question1Answer,
                  questionText:this.dynaQuestions["question1"]["questionText"]
                },
                question2:{
                  answer:this.question2Answer,
                  questionText:this.dynaQuestions["question2"]["questionText"]},
                question3:{
                  answer:this.selected,
                  questionText:this.dynaQuestions["question3"]["questionText"]},
                question4:{
                  answer:this.question4Answer,
                  questionText:this.dynaQuestions["question4"]["questionText"]}}
              



            
                //this.$store.commit('assessment_form_store/SET_QUESTION',{formid:this.$options.name, questionid:'question3',value:value,region:this.region});
             this.$store.dispatch('conversations/submitAnswers',{
                
                docId:this.$store.state.user.currentUser.id,

                formDataObj:forminfo


          });
          this.show=false;
        this.$bvToast.toast(` Go Back to Research Lab `, {
                    to: '/worlds',

          title: `Form Info Saved`,
          autoHideDelay: 5000,
          appendToast: true
        })       


      },

      }
};
</script>

<style scoped>
  .btn span {
    font-size: 14px;
    font-weight: bold;
    color: #de1a21;
  }
  
  
.neu-button {
    border: 0px solid white;
    width: 18vw;
    height: 5vh;
    border-radius: 150px;
    background: #e5e5e5;
    box-shadow: 6px 6px 12px #B8B9BE, -6px -6px 12px #fff;
    line-height: 14px;
    display: flex;
    font-family: 'Montserrat', Helvetica, Arial, sans-serif !important;
    font-weight: bold;
    align-items: center;
    justify-content: center;
    margin: 2vh auto;
    color: #de1a21 !important;
    font-size: 1em;
    text-transform: uppercase;
}

.form-group{
  margin-bottom: 0px;
  margin-left:20%;
  margin-right:20%;
}
</style>


